.panel {
  height: 100%;
  border-right: 1px solid var(--color-border);
}

.category {
  padding: var(--spacing-md) var(--spacing-sm) var(--spacing-xs);
}

.categoryTitle {
  margin: 0 var(--spacing-sm) var(--spacing-xs);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-text-muted);
}

.list {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.list li,
.list li > span {
  display: flex;
  width: 100%;
}

.item {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  width: 100%;
  min-height: var(--hit-target);
  padding: 0 var(--spacing-md);
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--color-text);
  text-align: left;
}

.item:hover:not(:disabled) {
  background: var(--color-surface-hover);
}

.item:disabled {
  color: var(--color-text-muted);
}

.itemName {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
